import React from "react";
import './SkinAssessmentHomeFooter.scss';
import { Link } from "react-router-dom";
import SkinAssessmentButton from "../../../../../common/skinAssessmentButton/SkinAssessmentButton";
import { CustomCheckbox, SkeletonLoader } from "../../../../../common";
import { SKIN_ASM_CONSTANTS } from "../../../../../common/skinAssessmentConstant";

const SkinAssessmentHomeFooter = ({ detailResolved, assessmentHistory, checkboxRef, isAccepted, onAcceptChange, onOpenModal, redirectToAssessment, redirectToAssessmentAnonymous, redirectToAssessmentScore }) => {

    return (
        <div className={`skin-asm-footer ${assessmentHistory ? 'footer-height' : ''}`}>
            <div className="skin-asm-footer-gradient" />
            <img
                src="/images/skin-assessment/home-footer-bg.svg"
                alt="footer-img"
                className="skin-asm-footer-bg" />
            {!detailResolved ?
                <SkeletonLoader className="skin-asm-landing-page-footer" /> :
                <div className="skin-asm-footer-content">
                    <img
                        src="/images/skin-assessment/assessment-details.svg"
                        alt="footer-assessment-img"
                        className="skin-asm-footer-content-img" />
                    {!assessmentHistory &&
                        <div className="skin-asm-footer-content-link-wrapper">
                            <CustomCheckbox ref={checkboxRef} onChange={onAcceptChange} accept={isAccepted} checkedImgSrc="/images/skin-assessment/radio-btn-active.svg" uncheckedImgSrc="/images/skin-assessment/radio-btn-inactive.svg" />
                            <div className="footer-asm-link">
                                <Link className="" to="#" onClick={(e) => {
                                    e.preventDefault();
                                    onOpenModal();
                                }}>{SKIN_ASM_CONSTANTS.FOOTER_CONDITION_LINK_TEXT}</Link>
                            </div>
                        </div>
                    }
                    {!assessmentHistory ?
                        <>
                            <SkinAssessmentButton disabled={!isAccepted} btnClassName={isAccepted ? "home-start-gradient" : "home-start-disabled"} onBtnClick={(e) => {
                                e.preventDefault();
                                redirectToAssessment();
                            }}>{SKIN_ASM_CONSTANTS.START_ASSESSMENT_BTN_TEXT}
                            </SkinAssessmentButton>
                        </> :
                        <>
                            <div className="skin-asm-button-div">
                                <SkinAssessmentButton btnClassName="footer-back" onBtnClick={(e) => {
                                    e.preventDefault();
                                    redirectToAssessmentScore();
                                }}>{SKIN_ASM_CONSTANTS.GOTO_RESULT_PAGE_TEXT}
                                </SkinAssessmentButton>
                                <SkinAssessmentButton btnClassName="home-start-gradient" onBtnClick={(e) => {
                                    e.preventDefault();
                                    redirectToAssessment();
                                }}>{SKIN_ASM_CONSTANTS.START_ASSESSMENT_POPUP_TITLE}
                                </SkinAssessmentButton>
                            </div>
                        </>}
                    {!assessmentHistory ?
                        <div className="footer-asm-link link2">
                            <Link className={isAccepted ? "link-enabled" : "link-disabled"} to="#" onClick={(e) => {
                                if (!isAccepted) {
                                    e.preventDefault();
                                    return;
                                }
                                e.preventDefault();
                                redirectToAssessmentAnonymous();
                            }}>{SKIN_ASM_CONSTANTS.START_ANONYMOUS_LINK_TEXT}</Link>
                        </div> :
                        <div className="footer-asm-link link2">
                            <Link className={"link-enabled"} to="#" onClick={(e) => {
                                e.preventDefault();
                                redirectToAssessmentAnonymous();
                            }}>{SKIN_ASM_CONSTANTS.START_ANONYMOUS_LINK_TEXT}</Link>
                        </div>}
                </div>
            }
        </div>
    )
}

export default SkinAssessmentHomeFooter;